import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SchoolServices } from '../services';
import { Globals } from '../../../globals';
import * as moment from 'moment';
import { ClassroomsCreateTeachersSelectPage } from '../classrooms-create/classrooms-create-teachers-select/classrooms-create-teachers-select';
import { ClassroomsListPage } from '../classrooms-list/classrooms-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-classrooms-view.html',
  templateUrl: 'classrooms-view.html',
})
export class ClassroomsViewPage {
  classroom: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public schoolServices: SchoolServices,
    public globals: Globals,
    public translate: TranslateService) {

    this.classroom = this.navParams.get('classroom');
    this.classroom.created_date = moment(this.classroom.created_at.toDate()).format("DD/MM/YYYY HH:MM");
  }

  onBack() {
    this.navCtrl.setRoot(ClassroomsListPage);
  }

  editClassroom() {
    this.navCtrl.push(ClassroomsCreateTeachersSelectPage, {
      update_state: true,
      classroom: this.classroom,
    });
  }

  async delete() {
    let alert = this.alertCtrl.create({
      title:  this.translate.instant('general-eliminar-curso'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteClassroom();

          }
        }
      ]
    });
    alert.present();
  }

  async deleteClassroom() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-eliminando-curso')
    });
    loadingPopup.present();

    //eliminar alumnos de profesores
    //await this.schoolServices.deleteStudentsFromTeacherOfClassroom(this.classroom.UID);
    //eliminar de classroom
    await this.schoolServices.deleteClassroom(this.classroom.UID);

    loadingPopup.dismiss();
    this.navCtrl.setRoot(ClassroomsListPage);

  }

}



// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-view/classrooms-view.ts